import React, {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography'; 
import TextField from '@mui/material/TextField';
import {StyledFormContainer} from '../Components/Styled/index';
import Button from '@mui/material/Button';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import history from '../Utility/history';
import { publicRoutesPath } from '../Routes';
import axios from 'axios';
import {useSnackbar} from 'notistack';
import { useSelector, useDispatch } from 'react-redux';
import BiztantuLoader from '../Components/Loader';
import { requestHideLoader } from '../Store/Global/action';
import { IconButton, InputAdornment } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import bticon from '../Assets/images/biztantu-logo-full.png';
const theme = createTheme({
    typography: {
      subtitle2: {
        fontStyle: 'italic',
      }
    },
});


const FisrtUserPasswordSetup = (props) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [currentUser , setCurrentUser] = useState({
        newpassword: '',
        retypenewpassword: ''
    });

    const [showPassword, setShowPassword] = useState(false);
    const [resetNewPassword, setResetnewPassword] = useState(false);

    const allowedCharacters = /^[a-zA-Z0-9 ]*$/;
       
    const currentUserData = history?.location?.state?.currentUserData;
   
    const [requiredError, setRequiredError] = useState({
        newpassword: false,
        retypenewpassword: false,
        helperText: "",
        specialcharWarning: ""
    })

    // console.log("state data", history?.location?.state);
    
    const dispatch = useDispatch();

    const isLoading = useSelector(state => state.global.isLoading)

//     useEffect(() => {
//         renderSpecificRoutes();
//     },[specificRolePermission])

//   const renderSpecificRoutes = () => {
      
//       if(specificRolePermission?.isDashboradView) {
//           history.push(privateRoutesPath.DASHBOARD);
//           return true;
//         }
  
//         if(specificRolePermission?.isLeadView) {
//           history.push(privateRoutesPath.LEADS);
//           return true;
//         }
  
//         if(specificRolePermission?.isCustomerView) {
//           history.push(privateRoutesPath.CUSTOMER);
//           return true;
//         }
  
//         if(specificRolePermission?.isMerchantView) {
//           history.push(privateRoutesPath.MERCHANT);
//           return true;
//         }
  
//         if(specificRolePermission?.isProductView) {
//           history.push(privateRoutesPath.PRODUCT);
//           return true;
//         }
  
//         if(specificRolePermission?.isOrderView) {
//           history.push(privateRoutesPath.ORDER);
//           return true;
//         }
  
//         if(specificRolePermission?.isInvoiceView) {
//           history.push(privateRoutesPath.INVOICE);
//           return true;
//         }
  
//         if(specificRolePermission?.isConfigurationView) {
//           history.push(privateRoutesPath.CONFIGURATION);
//           return true;
//         }

//   }

    //handle input formfield
    const handleChange = (event) => {
        
        const{ name , value} = event.target;
           
        // const allowedCharacters = /^[a-zA-Z0-9 ]*$/;
        // if (allowedCharacters.test(value)) {
        //     // setCurrentUser({
        //     //     ...currentUser,
        //     //     [name]: value
        //     // })

        //     setRequiredError({
        //         ...requiredError,
        //         specialcharWarning: ""
        //     })
        // } else {
        //     setRequiredError({
        //         ...requiredError,
        //         specialcharWarning: "Special characters are not allowed."
        //     })
        // }

        // const{ name , value} = event.target;
        setCurrentUser({
            ...currentUser,
            [name]: value
        })
    }


    useEffect(() => {

        if(currentUser?.newpassword && currentUser?.retypenewpassword) {
            if(currentUser?.newpassword == currentUser?.retypenewpassword) {
                setRequiredError({
                    ...requiredError,
                    helperText: "",
                    retypenewpassword: false
                })
            } else {
                setRequiredError({
                    ...requiredError,
                    helperText: "Password should be same as per above field",
                    retypenewpassword: true
                })
            }
        }
       
    },[currentUser])

    //handle Login Button
    const handlelogin = async() => {
        // dispatch(requestShowLoader())
        // axios.post(`${process.env.REACT_APP_BASE_URL}authenticate`, currentUser).then(response => {
        //   const token = response?.data?.token;
        //   dispatch(requestHideLoader())
        //   if(token) {
        //     localStorage.setItem('accessToken', token);
        //     dispatch(requestgetcurrenctuser(token));
            
        //     // history.push(privateRoutesPath.DASHBOARD);
        //   }
          
        // }).catch(error => {
        //   dispatch(requestHideLoader())
        //   enqueueSnackbar(error?.response?.data?.error, {variant: 'error'});
        // })
        if(currentUser?.newpassword && currentUser?.retypenewpassword) {
            
            if((currentUser?.newpassword == currentUser?.retypenewpassword) && allowedCharacters?.test(currentUser?.newpassword)) {
                const url = `${process.env.REACT_APP_BASE_URL}users/resetPassword/${currentUserData?.userId}`;

                const headerReq = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${history?.location?.state?.token}`,
                    }
                }

                try {


                    const reqbody = {
                        id: currentUserData?.id,
                        userName: currentUserData?.username,
                        userPassword: currentUser?.retypenewpassword,
                        resetPassword: false
                    }
                    const responseData = await axios.put(url, reqbody, headerReq);

                    dispatch(requestHideLoader());

                    enqueueSnackbar("Password updated successfully.", {variant: "success"})
                 
                    history?.push(`${publicRoutesPath?.LOGIN}`);
                    
                    console.log("responseData in data");
    
                } catch(error) {

                    enqueueSnackbar("Please try again.", {variant: "error"})
                 
                    dispatch(requestHideLoader());
                }

            }
        } else {
            setRequiredError({
                newpassword: true,
                retypenewpassword: true
            })
        }
    }
 
  return (
    <BiztantuLoader open={isLoading} isChildren={true}>
    <ThemeProvider theme={theme}>
    <Box sx={{ flexGrow: 1 }}>
      <Grid 
        container 
        direction="row"
        flexWrap="nowrap"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        className="gridContainer"
      >
        <Grid item xs={8}></Grid>
        <Grid className='textCenter' item xs={8}>
            {/* <Typography variant="h6" gutterBottom component="div">
                {currentUserData?.client?.name}
            </Typography>
            <Typography variant="subtitle2" gutterBottom component="div">
                Powerd By BizTantu
            </Typography> */}
            <div style={{marginBottom: "20px"}}>
              <img src= {bticon} style={{width: "50%", height: "100%", objectFit: 'contain'}}/>
            </div>
                            
            <StyledFormContainer>
                <TextField 
                    id="outlined-basic" 
                    label="New password" 
                    variant="outlined" 
                    type={showPassword ? 'text' : 'password'}
                    className='mb-15'
                    name="newpassword"
                    onChange={handleChange}
                    value={currentUser.newpassword}
                    error = {currentUser?.newpassword ? allowedCharacters?.test(currentUser?.newpassword) ? false : true : requiredError?.newpassword}
                    required
                    helperText={allowedCharacters?.test(currentUser?.newpassword) ? "" : "Special Characters are not allowed"}
                    InputProps= {{endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword((show) => !show)}
                            onMouseDown={(event) => event.preventDefault()}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                          </IconButton>
                        </InputAdornment>
                      )}}
                    InputLabelProps={{
                      shrink: true,
                  }}
                  placeholder="Enter new password"
                />
                <TextField 
                    id="outlined-basic" 
                    label="Re-enter new password" 
                    variant="outlined" 
                    type={resetNewPassword ? 'text' : 'password'}
                    className='mb-15'
                    name="retypenewpassword"
                    onChange={handleChange}
                    value={currentUser?.retypenewpassword}
                    required
                    error={requiredError?.retypenewpassword}
                    InputProps= {{endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setResetnewPassword((show) => !show)}
                            onMouseDown={(event) => event.preventDefault()}
                            edge="end"
                          >
                            {resetNewPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                          </IconButton>
                        </InputAdornment>
                      )}}
                    InputLabelProps={{
                      shrink: true,
                  }}
                  helperText= {requiredError?.helperText}
                  placeholder="Re-enter new password"
                />

                <Button variant="contained" onClick={handlelogin}>Set Password</Button>
            </StyledFormContainer>
            
        </Grid>
        <Grid item xs={8}></Grid>
      </Grid>
    </Box>
    </ThemeProvider>
    </BiztantuLoader>
  );
}


export default FisrtUserPasswordSetup;